module.exports = __webpack_public_path__ + "media/connectivity-slide1.0e560a53.mp4";